import React from 'react';
import { useComparisonGrid } from '../providers/comparison_grid';
import Cell from './cell';
const Column = (props) => {
    const { doc, columnId } = props;
    const { tagsColumnNames } = useComparisonGrid();
    return (React.createElement("div", { className: 'column' }, tagsColumnNames.map((value, index) => {
        const rowIndex = index + 1;
        const cellId = `${columnId}-${rowIndex}`;
        return React.createElement(Cell, { key: `cell-${cellId}`, cellId: cellId, rowIndex: rowIndex, doc: doc, tagRowName: value });
    })));
};
export default Column;
